import { Link, Navigate, Outlet } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LoadingPage } from '@/components/ui/loading-page';
import { ThemeToggleSimple } from '@/components/ui/theme-toggle-simple';
import { usePermissions } from '@/hooks/usePermissions';
import { useLogout } from '@/hooks/useLogout';
import { can } from '@/utils/permissions';

export function InstructorShell() {
  const { permissions, adminType, loading } = usePermissions();
  const { performLogout } = useLogout();

  if (loading) {
    return <LoadingPage message="Checking access…" />;
  }

  if (!can(permissions, 'forms.appointments.attendance.view', adminType)) {
    return <Navigate to="/forbidden" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-border/60 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3">
          <div className="flex min-w-0 items-center gap-3">
            <Link
              to="/instructor"
              className="flex min-w-0 items-center gap-3 text-foreground hover:text-primary"
            >
              <img
                src="/logo.png"
                alt="Join Americation"
                className="h-9 w-auto shrink-0 object-contain"
              />
            </Link>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <ThemeToggleSimple />
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="gap-2"
              onClick={() => void performLogout({ redirectTo: '/login' })}
            >
              <LogOut className="h-4 w-4" />
              Log out
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
